import {memo} from 'react'

import {StarIcon} from '@primer/octicons-react'

import {Label} from '@primer/react'

import type {AgentFinderEntry} from '../../../../types'

import {getMediaTypeLabel} from '../../media-types'

import styles from './GridCard.module.css'

type Props = {
  entry: AgentFinderEntry
}

// Maps an extension type label to a Primer Label scheme so different types
// are visually distinguishable at a glance.
function schemeForType(extensionType: string): React.ComponentProps<typeof Label>['variant'] {
  switch (extensionType.toLowerCase()) {
    case 'mcp server':
      return 'accent'
    case 'agent':
      return 'success'
    case 'a2a agent':
      return 'sponsors'
    case 'skill':
      return 'attention'
    case 'canvas':
      return 'severe'
    default:
      return 'secondary'
  }
}

export const GridCard = memo(function GridCardComponent(props: Props) {
  const {entry} = props
  const typeLabel = getMediaTypeLabel(entry.type)
  const likes = entry.metadata?.likes

  return (
    <div className={styles.card}>
      <div className={styles.body}>
        <div className={styles.header}>
          <div className={styles.heading}>
            <span className={styles.title}>{entry.displayName}</span>
          </div>

          {typeLabel ? (
            <div className={styles.typeLabel}>
              <Label className={styles.typeLabelContent} variant={schemeForType(typeLabel)}>
                {typeLabel}
              </Label>
            </div>
          ) : null}
        </div>

        <p className={styles.description}>{entry.description}</p>
      </div>

      <footer className={styles.footer}>
        {likes ? (
          <div className={styles.footerStats}>
            <StarIcon size={14} aria-hidden="true" />

            <span className="sr-only">
              {likes.toLocaleString()} <span>{likes === 1 ? 'like' : 'likes'}</span>
            </span>
            <span aria-hidden="true">{likes.toLocaleString()}</span>
          </div>
        ) : null}
      </footer>
    </div>
  )
})
